module.exports = __webpack_public_path__ + "img/icon-body-inactive.7dd45c69.png";